export function pluralize(value: number, unit: string) {
  return `${value} ${unit}${value === 1 ? "" : "s"}`;
}

export function formatCountdown({
  days,
  hours,
  minutes,
  seconds,
}: {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}) {
  const parts: string[] = [];
  if (days > 0) parts.push(pluralize(days, "day"));
  parts.push(pluralize(hours, "hour"));
  parts.push(pluralize(minutes, "minute"));
  parts.push(pluralize(seconds, "second"));
  return parts.join(", ");
}
